<template>
  <base-page max-width="md:ps-max-w-md" class="ps-help " @dismiss="done">
    <div
      slot="header"
      class="px-4 py-5 sm:px-8 sm:py-6 border-b border-gray-200 "
    >
      <h3 class="text-lg leading-6 font-medium text-gray-600">
        Help
      </h3>
    </div>
    <p
      class="ps-text-gray-900 ps-text-lg ps-leading-6 ps-mx-8 ps-mt-8 ps-mb-0 ps-leading-normal"
    >
      We are a small team but we will do our best to provide fast and helpful
      support. Please choose a method below:
    </p>
    <div class="z-20 relative grid gap-6 px-5 py-6 sm:gap-8 sm:p-8  mt-2">
      <a
        :href="urlDashboard"
        target="_blank"
        class="-m-3 p-3 flex items-start ps-space-x-4 rounded-lg hover:bg-gray-50 transition ease-in-out duration-150"
      >
        <div
          class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md ps-bg-brand-orange text-white sm:h-12 sm:w-12"
        >
          <svg
            class="h-6 w-6"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
            ></path>
          </svg>
        </div>
        <div class="ps-space-y-1">
          <p class="text-base leading-6 font-medium text-gray-900">
            Live Chat
          </p>
          <p class="text-sm leading-5 text-gray-500">
            Start a quick conversation
          </p>
        </div>
      </a>

      <a
        href="mailto:help@picnic.team"
        class="-m-3 p-3 flex items-start ps-space-x-4 rounded-lg hover:bg-gray-50 transition ease-in-out duration-150"
      >
        <div
          class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md ps-bg-brand-orange text-white sm:h-12 sm:w-12"
        >
          <svg
            class="h-6 w-6"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            ></path>
          </svg>
        </div>
        <div class="ps-space-y-1">
          <p class="text-base leading-6 font-medium text-gray-900">
            help@picnic.team
          </p>
          <p class="text-sm leading-5 text-gray-500">
            Get help the old-fashioned way
          </p>
        </div>
      </a>

      <a
        href="#"
        class="-m-3 p-3 flex items-start ps-space-x-4 rounded-lg hover:bg-gray-50 transition ease-in-out duration-150 opacity-25"
      >
        <div
          class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md ps-bg-gray-400 text-white sm:h-12 sm:w-12"
        >
          <svg
            class="h-6 w-6"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
            ></path>
          </svg>
        </div>
        <div class="ps-space-y-1">
          <p class="text-base leading-6 font-medium text-gray-900">
            Learn
            <span
              class=" px-2 py-1 text-teal-800 text-xs leading-4 font-medium bg-teal-100 rounded-full"
            >
              Coming Soon
            </span>
          </p>
          <p class="text-sm leading-5 text-gray-500 ps-mb-2">
            View Picnic documentation
          </p>
        </div>
      </a>
    </div>
  </base-page>
</template>

<script>
import { mapMutations, mapGetters } from '@picnic-software/vuex'
import BasePage from '@/components/BasePage'
import ButtonPrimary from '@/components/buttons/ButtonPrimary'
import LinkWithIcon from '@/components/LinkWithIcon'
import { ROUTE_CONTROLS } from '@/common/constants'

export default {
  name: 'AppHelp',
  components: {
    BasePage,
    ButtonPrimary,
    LinkWithIcon
  },
  computed: {
    ...mapGetters({
      isModeSpace: 'app/isModeSpace'
    }),
    urlDashboard() {
      return `${process.env.VUE_APP_URL_DASHBOARD}/support`
    },
    url101() {
      return process.env.VUE_APP_URL_101
    }
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to'
    }),
    done() {
      this.routerTo(ROUTE_CONTROLS)
    }
  }
}
</script>
